
// local constants used across the application
export const localStorageKeys = {
  EmsUser: "EMSUser",
  EmsToken: "EMSToken",
};
export const USER_TYPE = {
  SELF_SERVICE_ADMIN: 1,
  ADMIN: 2,
}

export enum PAYMENT_STATUS_VALUE {
  PENDING = 1,
  SUCCESS = 2,
  UNPAID = 3,
  PAID = 4,
  AWAITING_VENDING = 5,
  FAILED = 6,
}

export enum WALLET_TRANSACTION_STATUS {
  PENDING = 1,
  UNPAID = 3,
  PAID = 4,
}
export enum TwoFactortypes {
  Email = 1,
  GoogleAuth = 2,
}
export enum PaymentMethod {
     Wallet = 1,
     Remita = 2,
}

export const paymentStatuses = [
  {label: 'All', value: -1,},
  {label: 'Pending', value: PAYMENT_STATUS_VALUE.PENDING},
  {label: 'Approved', value: PAYMENT_STATUS_VALUE.SUCCESS},
  {label: 'Declined', value: PAYMENT_STATUS_VALUE.FAILED},
  {label: 'Paid', value: PAYMENT_STATUS_VALUE.PAID},
  {label: 'Unpaid', value: PAYMENT_STATUS_VALUE.UNPAID},
]
export const walletTransactionStatuses = [
  {label: 'All', value: -1,},
  {label: 'Pending', value: WALLET_TRANSACTION_STATUS.PENDING},
  {label: 'Unpaid ', value: WALLET_TRANSACTION_STATUS.UNPAID},
  {label: 'Success', value: WALLET_TRANSACTION_STATUS.PAID},
]

export const paymentMethods = [
  {label: 'All', value: -1,},
  {label: 'Online', value: PaymentMethod.Remita},
  {label: 'Wallet', value: PaymentMethod.Wallet},
   
]

export const PAYMENT_STATUS = {
  UNPAID: "Unpaid invoice",
  SUCCESS: "Successful",
  PAID: "Paid invoice",
  AWAITING_VENDING: "Awaiting vending",
  PENDING: "Pending",
  FAILED: "Failed",
};


export const WALLET_TRANSACTION_STATUS_LABELS = {
  [WALLET_TRANSACTION_STATUS.UNPAID]: "Unpaid",
  [WALLET_TRANSACTION_STATUS.PENDING]: "Pending",
  [WALLET_TRANSACTION_STATUS.PAID]: "Paid",
};